import React from 'react';
import { Document } from '@contentful/rich-text-types';
import CrazyFont from '@jbhi-fi/lanyard-ui/font/CrazyFont';
import { RichText } from '../../RichText';
import { styles } from './BundleModule.css';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type BundleModuleProps = {
  className?: string;
  titleTag?: string;
  heading: string;
  content?: Document;
  disclaimer?: Document;
};

export const BundleModule = ({
  titleTag = 'Bundle Deal!',
  heading,
  content,
  disclaimer,
  className,
}: BundleModuleProps) => {
  return (
    <div className={classNames(styles.container, className)}>
      <CrazyFont variant="withShadowAndOutline" as="h3" className={styles.titleTag}>
        {titleTag}
      </CrazyFont>
      {heading ? <h3 className={styles.heading}>{heading}</h3> : null}
      {content ? <RichText document={content} containerClass={styles.content} /> : null}
      {disclaimer ? <RichText document={disclaimer} containerClass={styles.disclaimer} /> : null}
    </div>
  );
};
